import React from "react";

import style from "./style.module.css";

export default function Text({ text, className = "" }) {
    return (
        <div className={`${className ? className : ''}${style[className] ? ` ` + style[className] : ''}`} dangerouslySetInnerHTML={{ __html: text }}></div>
    )
}